import React, { forwardRef, useEffect, useRef } from 'react';
import { useEvent, useForwardedRef } from '@anton.bobrov/react-hooks';
import { useTimeline } from '@anton.bobrov/react-vevet-hooks';
import cn from 'classnames';
import { prefixedClasNames } from '../../utils/prefixedClassNames';
import { useStates } from './utils/useStates';
import { render } from './utils/render';
/** Accordion base */
export var ExpandContent = forwardRef(function (_a, forwardedRef) {
    var className = _a.className, style = _a.style, _b = _a.isActive, isActiveProp = _b === void 0 ? false : _b, _c = _a.duration, durationProp = _c === void 0 ? 500 : _c, _d = _a.hasAlpha, hasAlpha = _d === void 0 ? true : _d, _e = _a.isContentRendered, isContentRenderedProp = _e === void 0 ? true : _e, onAnimationRenderProp = _a.onAnimationRender, onAnimationEndProp = _a.onAnimationEnd, children = _a.children;
    var parentRef = useForwardedRef(forwardedRef);
    var contentRef = useRef(null);
    var onAnimationRender = useEvent(onAnimationRenderProp);
    var onAnimationEnd = useEvent(onAnimationEndProp);
    var _f = useStates({
        isActive: isActiveProp,
        duration: durationProp,
        isContentRendered: isContentRenderedProp,
    }), isActive = _f.isActive, setIsFirstExpand = _f.setIsFirstExpand, isContentRendered = _f.isContentRendered, duration = _f.duration;
    var _g = useTimeline({
        duration: duration,
        onProgress: function (_a) {
            var progress = _a.progress;
            render({
                parentRef: parentRef,
                contentRef: contentRef,
                timeline: timeline,
                progress: progress,
                hasAlpha: hasAlpha,
                onRender: onAnimationRender,
                onEnd: function (data) {
                    onAnimationEnd === null || onAnimationEnd === void 0 ? void 0 : onAnimationEnd(data);
                    setIsFirstExpand(false);
                },
            });
        },
    }), play = _g.play, reverse = _g.reverse, timeline = _g.timeline;
    useEffect(function () {
        if (!timeline) {
            return;
        }
        if (isActive) {
            play();
        }
        else {
            reverse();
        }
    }, [isActive, play, reverse, timeline]);
    return (React.createElement("div", { ref: parentRef, className: cn(className, prefixedClasNames('expand-content')), style: style },
        React.createElement("div", { ref: contentRef, className: prefixedClasNames('expand-content__content') }, isContentRendered && children)));
});
ExpandContent.displayName = 'ExpandContent';
//# sourceMappingURL=index.js.map